import React from "react";

import Email from "@mapmycustomers/shared/types/email/Email";
import EmailAttachment from "@mapmycustomers/shared/types/email/EmailAttachment";

import styles from "./EmailAttachmentsList.module.scss";
import EmailAttachmentView from "./EmailAttachmentView";

interface EmailAttachmentsListProps {
  attachments: EmailAttachment[];
  messageId: Email["messageId"];
}

const EmailAttachmentsList: React.FC<EmailAttachmentsListProps> = ({ attachments, messageId }) => {
  if (!attachments.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      {attachments.map((attachment) => (
        <EmailAttachmentView attachment={attachment} key={attachment.id} messageId={messageId} />
      ))}
    </div>
  );
};

export default EmailAttachmentsList;
